(function () {
    document.cookie = `GMT=${-1 * (new Date().getTimezoneOffset() / 60)};path=/`;
})();
